import { FC, useContext } from 'react';
import { AlllieListStyled, QuickStopReasonAssignButtons } from '../AssignReasonForm.styles';
import { AllieText, useWizardContext } from '../../../../components';
import { AssignReasonFormContext } from '../AssignReasonForm.context';
import { Step1Props } from '../AssignReasonForm.types';

export const Step1: FC<Step1Props> = ({ labels }) => {
  const { stepData, setStepData } = useContext(AssignReasonFormContext);
  const { goNextPage } = useWizardContext();

  return (
    <>
      <AlllieListStyled className="step-1">
        <QuickStopReasonAssignButtons
          button
          detail
          isSelected={stepData.step1?.typeStop === 'planned'}
          onclick={() => {
            setStepData({
              ...stepData,
              step1: {
                ...stepData.step1,
                typeStop: 'planned',
              },
              ...(stepData.step1.typeStop != 'planned' && {
                step2: {
                  groupMotive: undefined,
                  motive: undefined,
                },
              }),
            });
            goNextPage();
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <AllieText
              color={stepData.step1?.typeStop === 'planned' ? 'white' : 'neutral-90'}
              weight={500}
            >
              {labels.planned}
            </AllieText>
          </div>
        </QuickStopReasonAssignButtons>
        <QuickStopReasonAssignButtons
          button
          detail
          isSelected={stepData.step1?.typeStop === 'unplanned'}
          data-testid="next-button"
          onclick={() => {
            setStepData({
              ...stepData,
              step1: {
                ...stepData.step1,
                typeStop: 'unplanned',
              },
              ...(stepData.step1.typeStop != 'unplanned' && {
                step2: {
                  groupMotive: undefined,
                  motive: undefined,
                },
              }),
            });
            goNextPage();
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <AllieText
              color={stepData.step1?.typeStop === 'unplanned' ? 'white' : 'neutral-90'}
              weight={500}
            >
              {labels.unplanned}
            </AllieText>
          </div>
        </QuickStopReasonAssignButtons>
      </AlllieListStyled>
    </>
  );
};
